// import React, { ReactNode, useEffect } from 'react';

// //import actions
// import {
//     changeLayout,
//     changeSidebarTheme,
//     changeLayoutMode,
//     changeLayoutWidth,
//     changeLayoutPosition,
//     changeTopbarTheme,
//     changeLeftsidebarSizeType,
//     changeLeftsidebarViewType,
//     changeSidebarImageType,
//     changeBodyImageType
// } from "slices/thunk";

// //redux
// import { useSelector, useDispatch } from "react-redux";
// // import TopBar from './TopBar';

// import Header from './Header';
// import Sidebar from './Sidebar';
// import Footer from './Footer';
// import { changeLayoutTheme } from 'slices/layouts/thunk';
// import withRouter from 'Common/withRouter';
// import { createSelector } from 'reselect';

// interface LayoutProps {
//     children: ReactNode;
// }
// const Layout = (props: LayoutProps) => {

//     const dispatch: any = useDispatch();
//     const selectLayoutProperties = createSelector(
//         (state: any) => state.Layout,
//         (layout) => ({
//             layoutType: layout.layoutType,
//             layoutThemeType: layout.layoutThemeType,
//             leftSidebarType: layout.leftSidebarType,
//             layoutModeType: layout.layoutModeType,
//             layoutWidthType: layout.layoutWidthType,
//             layoutPositionType: layout.layoutPositionType,
//             topbarThemeType: layout.topbarThemeType,
//             leftsidbarSizeType: layout.leftsidbarSizeType,
//             leftSidebarViewType: layout.leftSidebarViewType,
//             leftSidebarImageType: layout.leftSidebarImageType,
//             bodyImageType: layout.bodyImageType
//         })
//     );

//     const {
//         layoutType,
//         layoutThemeType,
//         leftSidebarType,
//         layoutModeType,
//         layoutWidthType,
//         layoutPositionType,
//         topbarThemeType,
//         leftsidbarSizeType,
//         leftSidebarViewType,
//         leftSidebarImageType,
//         bodyImageType
//     } = useSelector(selectLayoutProperties);

//     /*
//     layout settings
//     */
//     useEffect(() => {
//         if (
//             layoutType ||
//             layoutThemeType ||
//             leftSidebarType ||
//             layoutModeType ||
//             layoutWidthType ||
//             layoutPositionType ||
//             topbarThemeType ||
//             leftsidbarSizeType ||
//             leftSidebarViewType ||
//             leftSidebarImageType ||
//             bodyImageType
//         ) {
//             window.dispatchEvent(new Event('resize'));
//             dispatch(changeLeftsidebarViewType(leftSidebarViewType));
//             dispatch(changeLayoutTheme(layoutThemeType));
//             dispatch(changeLeftsidebarSizeType(leftsidbarSizeType));
//             dispatch(changeSidebarTheme(leftSidebarType));
//             dispatch(changeLayoutMode(layoutModeType));
//             dispatch(changeLayoutWidth(layoutWidthType));
//             dispatch(changeLayoutPosition(layoutPositionType));
//             dispatch(changeTopbarTheme(topbarThemeType));
//             dispatch(changeLayout(layoutType));
//             dispatch(changeSidebarImageType(leftSidebarImageType));
//             dispatch(changeBodyImageType(bodyImageType));
//         }
//     }, [layoutType,
//         layoutThemeType,
//         leftSidebarType,
//         layoutModeType,
//         layoutWidthType,
//         layoutPositionType,
//         topbarThemeType,
//         leftsidbarSizeType,
//         leftSidebarViewType,
//         leftSidebarImageType,
//         bodyImageType,
//         dispatch]);

//     return (
//         <React.Fragment>
//             <div id="layout-wrapper">
//                 <Sidebar layoutType={layoutType} />
//                 <Header />
//                 <div className="main-content">
//                     {props.children}
//                     <Footer />
//                 </div>
//             </div>
//             {/* <RightSidebar /> */}
//         </React.Fragment>
//     );
// }

// export default withRouter(Layout);


import React, { ReactNode, useEffect, useState } from 'react';
//import actions
import {
    changeLayout,
    changeSidebarTheme,
    changeLayoutMode,
    changeLayoutWidth,
    changeLayoutPosition,
    changeTopbarTheme,
    changeLeftsidebarSizeType,
    changeLeftsidebarViewType,
    changeSidebarImageType,
    changeBodyImageType
} from "slices/thunk";
//redux
import { useSelector, useDispatch } from "react-redux";
// import TopBar from './TopBar';
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';
import { changeLayoutTheme } from 'slices/layouts/thunk';
import withRouter from 'Common/withRouter';
import { createSelector } from 'reselect';
interface LayoutProps {
    children: ReactNode;
}
const Layout = (props: LayoutProps) => {
  const [isMobileSidebarVisible, setMobileSidebarVisible] = useState(false);
const [isSidebarVisible, setIsSidebarVisible] = useState(true);
// const handleToggleSidebar = () => {
//   setIsSidebarVisible((prev) => !prev);
// };
const [windowWidth, setWindowWidth] = useState(window.innerWidth);
useEffect(() => {
  const handleResize = () => setWindowWidth(window.innerWidth);
  window.addEventListener('resize', handleResize);
  return () => window.removeEventListener('resize', handleResize);
}, []);
  const handleToggleSidebar = () => {
    // setMobileSidebarVisible(!isMobileSidebarVisible);
  setIsSidebarVisible((prev) => !prev);
  };
    const dispatch: any = useDispatch();
    const selectLayoutProperties = createSelector(
        (state: any) => state.Layout,
        (layout) => ({
            layoutType: layout.layoutType,
            layoutThemeType: layout.layoutThemeType,
            leftSidebarType: layout.leftSidebarType,
            layoutModeType: layout.layoutModeType,
            layoutWidthType: layout.layoutWidthType,
            layoutPositionType: layout.layoutPositionType,
            topbarThemeType: layout.topbarThemeType,
            leftsidbarSizeType: layout.leftsidbarSizeType,
            leftSidebarViewType: layout.leftSidebarViewType,
            leftSidebarImageType: layout.leftSidebarImageType,
            bodyImageType: layout.bodyImageType
        })
    );
    const {
        layoutType,
        layoutThemeType,
        leftSidebarType,
        layoutModeType,
        layoutWidthType,
        layoutPositionType,
        topbarThemeType,
        leftsidbarSizeType,
        leftSidebarViewType,
        leftSidebarImageType,
        bodyImageType
    } = useSelector(selectLayoutProperties);
    /*
    layout settings
    */
    useEffect(() => {
        if (
            layoutType ||
            layoutThemeType ||
            leftSidebarType ||
            layoutModeType ||
            layoutWidthType ||
            layoutPositionType ||
            topbarThemeType ||
            leftsidbarSizeType ||
            leftSidebarViewType ||
            leftSidebarImageType ||
            bodyImageType
        ) {
            window.dispatchEvent(new Event('resize'));
            dispatch(changeLeftsidebarViewType(leftSidebarViewType));
            dispatch(changeLayoutTheme(layoutThemeType));
            dispatch(changeLeftsidebarSizeType(leftsidbarSizeType));
            dispatch(changeSidebarTheme(leftSidebarType));
            dispatch(changeLayoutMode(layoutModeType));
            dispatch(changeLayoutWidth(layoutWidthType));
            dispatch(changeLayoutPosition(layoutPositionType));
            dispatch(changeTopbarTheme(topbarThemeType));
            dispatch(changeLayout(layoutType));
            dispatch(changeSidebarImageType(leftSidebarImageType));
            dispatch(changeBodyImageType(bodyImageType));
        }
    }, [layoutType,
        layoutThemeType,
        leftSidebarType,
        layoutModeType,
        layoutWidthType,
        layoutPositionType,
        topbarThemeType,
        leftsidbarSizeType,
        leftSidebarViewType,
        leftSidebarImageType,
        bodyImageType,
        dispatch]);
          useEffect(() => {
  const handleCloseSidebar = () => {
    if (window.innerWidth <= 768) {
      setMobileSidebarVisible(false); // :point_left: close the sidebar
    }
  };
  window.addEventListener("closeSidebarOnMobile", handleCloseSidebar);
  return () => {
    window.removeEventListener("closeSidebarOnMobile", handleCloseSidebar);
  };
}, []);
 useEffect(() => {
  const handleCloseSidebar = () => {
    if (window.innerWidth <= 768) {
      setMobileSidebarVisible(false); // :point_left: close the sidebar
    }
  };
  window.addEventListener("closeSidebarOnMobile", handleCloseSidebar);
  return () => {
    window.removeEventListener("closeSidebarOnMobile", handleCloseSidebar);
  };
}, []);
    return (
        <React.Fragment>
<div style={{ display: 'flex', overflow: 'hidden', position: 'relative' }}>
      {/* Sidebar */}
      {/* <div
        className={`sidebar-wrapper ${isSidebarVisible ? 'd-block' : 'd-none'}`}
        style={{
          width: '200px',
          background: '#F8F9FA',
          overflowY: 'auto',
          flexShrink: 0,
          zIndex: 1000,
          position: 'fixed',
          height: '100%',
          left: 0,
          top: 0
        }}
      >
        <Sidebar layoutType={layoutType} />
      </div> */}
      <div
  className={`sidebar-wrapper ${isSidebarVisible ? 'd-block' : 'd-none'}`}
  style={{
    width: isSidebarVisible ? '200px' : '0px',
    transition: 'width 0.3s ease',
    background: '#F8F9FA',
    overflowY: 'auto',
    flexShrink: 0,
    zIndex: 1000,
    position: 'fixed',
    height: '100%',
    left: 0,
    top: 0
  }}
>
  <Sidebar layoutType={layoutType} />
</div>
      {/* Main Content Wrapper */}
      <div
        className="content-wrapper d-flex flex-column w-100"
         style={{
    flexGrow: 1,
    overflow: 'hidden',
    minHeight: '100vh',
    // marginLeft: window.innerWidth >= 768 ? (isSidebarVisible ? '200px' : '0px') : '0px',
    marginLeft: windowWidth >= 768 ? (isSidebarVisible ? '200px' : '0px') : '0px',
    transition: 'margin-left 0.3s ease'
  }}
      >
        {/* Header */}
        {/* <Header onToggleSidebar={handleToggleSidebar} /> */}
       <Header
  onToggleSidebar={handleToggleSidebar}
  isSidebarOpen={isSidebarVisible}
/>
        {/* Main Content */}
        <div
          style={{
            flex: 1,
            overflowY: 'auto',
            padding: '16px',
            background: '#fff'
          }}
        >
          {props.children}
        </div>
        {/* Footer */}
        <Footer />
      </div>
    </div>
            {/* <RightSidebar /> */}
        </React.Fragment>
    );
}
export default withRouter(Layout);
